// extracted by mini-css-extract-plugin
export const sectionRoot = "styles-module--sectionRoot--e6Vji";
export const txtSubTitle = "styles-module--txtSubTitle--9+KsO";
export const txtStep = "styles-module--txtStep--6Ebeb";
export const contentRoot = "styles-module--contentRoot--FLe02";
export const stepRoot = "styles-module--stepRoot--zRncI";
export const stepIcon = "styles-module--stepIcon--5T77I";
export const stepTitle = "styles-module--stepTitle--kwCMl";
export const stepSubTitle = "styles-module--stepSubTitle--7Esz7";